"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceSetupIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const PlaceSetupIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 4 24 24" }),
    react_1.default.createElement("path", { d: "M4.18508 8.22265C4.27781 8.08355 4.43392 8 4.6011 8H17.3993C17.5664 8 17.7225 8.08355 17.8153 8.22265L20.4819 12.2226C20.7035 12.5549 20.4653 13 20.0659 13H1.93444C1.53509 13 1.29689 12.5549 1.51841 12.2227L4.18508 8.22265Z", fill: "white" }),
    react_1.default.createElement("path", { d: "M17.0002 14H19.0002V21.5C19.0002 21.7761 18.7763 22 18.5002 22H17.5002C17.224 22 17.0002 21.7761 17.0002 21.5V14Z", opacity: "0.6" }),
    react_1.default.createElement("path", { d: "M5.00018 14H3.00018V21.5C3.00018 21.7761 3.22403 22 3.50018 22H11.5002C11.7763 22 12.0002 21.7761 12.0002 21.5V14H10.0002V19H5.00018V14Z", opacity: "0.6" })));
exports.PlaceSetupIcon = PlaceSetupIcon;
exports.default = exports.PlaceSetupIcon;
